
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/travel-insurance/claim",
      function () {
        return require("private-next-pages/travel-insurance/claim/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/travel-insurance/claim"])
      });
    }
  